import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { CreatedFormRelease, LatestFormRelease } from '../../core';
import { Result } from '@digibricks/core';
export var FormReleaseMapper = /*#__PURE__*/function () {
  function FormReleaseMapper() {
    _classCallCheck(this, FormReleaseMapper);
  }

  _createClass(FormReleaseMapper, [{
    key: "toDomain",
    value: function toDomain(input) {
      var id = input.id,
          version = input.version,
          publishedVersion = input.publishedVersion,
          totalScore = input.totalScore,
          totalQuestions = input.totalQuestions,
          updatedAt = input.updatedAt;
      var createFormReleaseResponseOrError = CreatedFormRelease.create({
        version: version,
        publishedVersion: publishedVersion !== null && publishedVersion !== void 0 ? publishedVersion : null,
        totalScore: totalScore,
        totalQuestions: totalQuestions,
        updatedAt: updatedAt
      }, id);

      if (createFormReleaseResponseOrError.isFailure) {
        return Result.fail(createFormReleaseResponseOrError.error);
      }

      return createFormReleaseResponseOrError;
    }
  }, {
    key: "latestToDomain",
    value: function latestToDomain(input) {
      var _input$publishedVersi;

      return LatestFormRelease.create({
        formId: input.formId,
        version: input.version,
        publishedVersion: (_input$publishedVersi = input.publishedVersion) !== null && _input$publishedVersi !== void 0 ? _input$publishedVersi : null,
        createdAt: input.createdAt,
        updatedAt: input.updatedAt
      }, input.id);
    }
  }]);

  return FormReleaseMapper;
}();